import { Hotkeys } from 'constants/Hotkeys';
import React, { memo } from 'react';
import BottomBarOption from '../../FieldingSequenceFlow/components/SequenceBottomBar/components/BottomBarOption';
import { EndSequenceBottomBar } from './EndSequenceStyles';

interface IProps {
  onExitCallback: () => void;
  onSaveCallback: () => void;
  isChanged: boolean;
}

const EndSequence: React.FC<IProps> = (props) => {
  const { onExitCallback, onSaveCallback, isChanged } = props;

  return (
    <EndSequenceBottomBar>
      <BottomBarOption
        className='exit-sequence'
        displayName='Discard'
        hotkey={Hotkeys.BaseRunners.ExitSequence.hotkeyDisplay}
        keyCode={Hotkeys.BaseRunners.ExitSequence.keyCode}
        label='Discard?'
        onPressHotkeyCallback={onExitCallback}
      />
      {isChanged && (
        <BottomBarOption
          className='finish-process'
          displayName='Finish process'
          hotkey={Hotkeys.BaseRunners.FinishProcess.hotkeyDisplay}
          keyCode={Hotkeys.BaseRunners.FinishProcess.keyCode}
          label='Finish process?'
          onPressHotkeyCallback={onSaveCallback}
        />
      )}
    </EndSequenceBottomBar>
  );
};

export default memo(EndSequence);
